module.exports = __webpack_public_path__ + "assets/img/demo-block.1e04d6c7.png";